import React from 'react';
import { TeachingStudio } from './TeachingStudio';

/** The paired touchscreen is always student-safe. */
export function ClassroomDisplay() {
  return <TeachingStudio display />;
}
